import Rest from './Rest';

export default class SearchApi {
  static async Post(deal, storeId, lang, data, highlightMode, searchMode = 'search') {
    const mode = highlightMode? 'searchforotherpubs': searchMode;
    const res = await Rest.Post(`/Pages/${deal}/${storeId}/${lang === 'fr' ? 'bil' : 'en'}/${mode}`, data);
    return res && res.data;
  }
}
